import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios';

const initialState = {
    website : null,
    websiteName : "",
    websites : [],
    isLoading : false,
    error : ''
}

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL
const API_URL = `${BACKEND_URL}/api/setting/website/`;

//Register Website
export const registerWebsite = createAsyncThunk(
  "website/register",
  async(formData, thunkAPI) => {
    try {
        const response = await axios.post(API_URL, formData)
        return response.data
    } catch (error) {
      const message = (
        error.response && error.response.data 
        && error.response.data.message) 
        || error.message || error.toString();
        console.log(message)
        return thunkAPI.rejectWithValue(message)
    }
  }
)

//Get All Websites
export const getWebsites = createAsyncThunk(
  "website/getAll",
  async(_, thunkAPI) => {
    try {
        const response = await axios.get(API_URL)
        return response.data
    } catch (error) {
      const message = (
        error.response && error.response.data 
        && error.response.data.message) 
        || error.message || error.toString();
        console.log(message)
        return thunkAPI.rejectWithValue(message)
    }
  }
)

export const getWebsiteFromUrl = createAsyncThunk(
  "website/getFromUrl",
  async(url, thunkAPI) => {
    try {
      console.log(url)
        const response = await axios.post(API_URL + 'searchurl', {url})
        return response.data
    } catch (error) {
      const message = (
        error.response && error.response.data 
        && error.response.data.message) 
        || error.message || error.toString();
        console.log(message)
        return thunkAPI.rejectWithValue(message)
    }
  }
)

//Get single Website
export const getWebsite = createAsyncThunk(
  "website/getOne",
  async(id, thunkAPI) => {
    try {
        const response = await axios.get(API_URL + id)
        return response.data
    } catch (error) {
      const message = (
        error.response && error.response.data 
        && error.response.data.message) 
        || error.message || error.toString();
        console.log(message)
        return thunkAPI.rejectWithValue(message)
    }
  }
)

export const deleteWebsite = createAsyncThunk(
  "website/delete",
  async(id, thunkAPI) => {
    try {
        const response = await axios.delete(API_URL + id)
        console.log(response)
        return response.data
    } catch (error) {
      const message = (
        error.response && error.response.data 
        && error.response.data.message) 
        || error.message || error.toString();
        console.log(message)
        return thunkAPI.rejectWithValue(message)
    }
  }
)

export const updateWebsite = createAsyncThunk(
  "website/update",
  async({id, formData}, thunkAPI) => {
    try {
        const response = await axios.patch(API_URL + id, formData)
        return response.data
    } catch (error) {
      const message = (
        error.response && error.response.data 
        && error.response.data.message) 
        || error.message || error.toString();
        console.log(message)
        return thunkAPI.rejectWithValue(message)
    }
  }
)

const websiteSlice = createSlice({
  name: "website",
  initialState,
  reducers: {
    CLEAR_FIELDS(state,action){
      state.website = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getWebsiteFromUrl.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getWebsiteFromUrl.fulfilled, (state, action) => {
        state.isLoading = false;
        state.websiteName = action.payload
      })
      .addCase(getWebsiteFromUrl.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload
      })
      .addCase(registerWebsite.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(registerWebsite.fulfilled, (state, action) => {
        state.isLoading = false;
        state.websites.push(action.payload);
      })
      .addCase(registerWebsite.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload
      })
      .addCase(getWebsites.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getWebsites.fulfilled, (state, action) => {
        state.isLoading = false;
        state.websites = (action.payload);
      })
      .addCase(getWebsites.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload
      })
      .addCase(getWebsite.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getWebsite.fulfilled, (state, action) => {
        state.isLoading = false;
        state.website = (action.payload);
      })
      .addCase(getWebsite.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload
      })
      .addCase(deleteWebsite.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(deleteWebsite.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(deleteWebsite.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload
      })
      .addCase(updateWebsite.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(updateWebsite.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updateWebsite.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload
      })
  }
});

export const selectIsLoading = (state) => state.website.isLoading
export const selectWebsites = (state) => state.website.websites
export const selectWebsite = (state) => state.website.website

export const {CLEAR_FIELDS} = websiteSlice.actions

export default websiteSlice.reducer